import React from 'react';
import { EyeIcon, EditIcon, TrashIcon, CheckIcon, GlobeIcon } from 'lucide-react';
export function CurrencyList({
  currencies,
  onSelectCurrency,
  onDeleteCurrency,
  locale
}) {
  return <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-17119">
      {currencies.length === 0 ? <div className="px-4 py-5 sm:p-6 text-center text-gray-500" data-id="element-17120">
          No currencies found. Add a new currency to get started.
        </div> : <table className="min-w-full divide-y divide-gray-200" data-id="element-17121">
          <thead className="bg-gray-50" data-id="element-17122">
            <tr data-id="element-17123">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17124">
                Code
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17125">
                Name
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17126">
                Symbol
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17127">
                Countries
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17128">
                Status
              </th>
              <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17129">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-17130">
            {currencies.map(currency => <tr key={currency.currencyId} onClick={() => onSelectCurrency(currency)} className="hover:bg-gray-50 cursor-pointer transition-colors" data-id="element-17131">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17132">
                  <div className="flex items-center" data-id="element-17133">
                    <div className="text-sm font-medium text-indigo-600" data-id="element-17134">
                      {currency.code}
                    </div>
                    <span className="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800" data-id="element-17135">
                      {currency.numericCode}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17136">
                  <div className="text-sm text-gray-900" data-id="element-17137">{currency.name}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17138">
                  <div className="text-sm text-gray-900" data-id="element-17139">{currency.symbol}</div>
                </td>
                <td className="px-6 py-4" data-id="element-17140">
                  <div className="text-sm text-gray-900 flex items-center" data-id="element-17141">
                    <GlobeIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-17142" />
                    <span data-id="element-17143">
                      {currency.countries.length > 2 ? `${currency.countries[0]}, ${currency.countries[1]} +${currency.countries.length - 2} more` : currency.countries.join(', ')}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17144">
                  {currency.isDefault ? <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-17145">
                      <CheckIcon className="h-4 w-4 mr-1" data-id="element-17146" />
                      Default
                    </span> : <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800" data-id="element-17147">
                      Active
                    </span>}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-17148">
                  <button onClick={e => {
              e.stopPropagation();
              onSelectCurrency(currency);
            }} className="text-green-600 hover:text-green-900 mr-3" title="View currency" data-id="element-17149">
                    <EyeIcon className="h-4 w-4" data-id="element-17150" />
                    <span className="sr-only" data-id="element-17151">View</span>
                  </button>
                  <button onClick={e => {
              e.stopPropagation();
              onSelectCurrency(currency);
            }} className="text-indigo-600 hover:text-indigo-900 mr-3" title="Edit currency" data-id="element-17152">
                    <EditIcon className="h-4 w-4" data-id="element-17153" />
                    <span className="sr-only" data-id="element-17154">Edit</span>
                  </button>
                  <button onClick={e => {
              e.stopPropagation();
              onDeleteCurrency(currency);
            }} className="text-red-600 hover:text-red-900 disabled:opacity-50 disabled:cursor-not-allowed" disabled={currency.isDefault} title={currency.isDefault ? 'Cannot delete default currency' : 'Delete currency'} data-id="element-17155">
                    <TrashIcon className="h-4 w-4" data-id="element-17156" />
                    <span className="sr-only" data-id="element-17157">Delete</span>
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>}
    </div>;
}